import { createFileRoute } from "@tanstack/react-router";
import { SearchTemplate } from "~/features/search/SearchTemplate";

export const Route = createFileRoute("/_authenticated/search/")({
  component: SearchTemplate,
});
